@file:OptIn(InternalResourceApi::class)

package imobly.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/imobly.composeapp.generated.resources/"

internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

internal val Res.drawable.image_logo: DrawableResource by lazy {
      DrawableResource("drawable:image_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/image_logo.png", -1, -1),
      ))
    }

internal val Res.drawable.image_logo_complete: DrawableResource by lazy {
      DrawableResource("drawable:image_logo_complete", setOf(
        ResourceItem(setOf(), "${MD}drawable/image_logo_complete.png", -1, -1),
      ))
    }

internal val Res.drawable.image_logo_white: DrawableResource by lazy {
      DrawableResource("drawable:image_logo_white", setOf(
        ResourceItem(setOf(), "${MD}drawable/image_logo_white.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("image_logo", Res.drawable.image_logo)
  map.put("image_logo_complete", Res.drawable.image_logo_complete)
  map.put("image_logo_white", Res.drawable.image_logo_white)
}
